module.exports = __webpack_public_path__ + "img/text3.98e59790.png";